import { render, staticRenderFns } from "./IndexPortfolioProfit.vue?vue&type=template&id=944f9900&scoped=true"
import script from "./IndexPortfolioProfit.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexPortfolioProfit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IndexPortfolioProfit.vue?vue&type=style&index=0&id=944f9900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f9900",
  null
  
)

export default component.exports